import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  isNewPerDiem?: boolean
}

export const PerDiemRatesSchema = ({ isNewPerDiem }: FormContext) => {
  return z.object({
    perDiemRates: z
      .array(
        z.object({
          id: z.number().optional().nullable(),
          rateConfigurationId: z.number().nullable(),
          units: z.number(),
          totalAmount: z.number(),
          rateAmount: z.number(),
          label: z.string().optional(),
          currency: z.string().optional(),
        })
      )
      .optional()
      .refine((data) => {
        if (isNewPerDiem) return true
        return data?.every(
          (rate) => rate.rateConfigurationId !== null && rate.rateConfigurationId !== undefined
        )
      }, i18n.t('expenses_v2.forms.fields.per_diem_rates.errors.rateConfigurationIdRequired')),
    deleted_rates: z.array(z.number()).optional(),
  })
}

export type PerDiemRatesSchema = z.infer<ReturnType<typeof PerDiemRatesSchema>>
